var floatingImages = [
    {
        element: document.getElementById('floating-image'),
        container: document.querySelector('.floating-image-container')
    },
    {
        element: document.getElementById('floating-fourth-image'),
        container: document.querySelector('.floating-image-fourth-container')
    }
];

floatingImages.forEach(function(floatingImage) {
    if (floatingImage.element && floatingImage.container) {

        const isDesktop = window.matchMedia("(min-width: 746px)").matches;

        if (isDesktop) {
            // Desktop: animación con el mouse
            floatingImage.container.addEventListener('mousemove', function(event) {
                var containerRect = floatingImage.container.getBoundingClientRect();
                var centerX = containerRect.left + containerRect.width / 2;
                var centerY = containerRect.top + containerRect.height / 2;
                var offsetX = (event.clientX - centerX) / 20;
                var offsetY = (event.clientY - centerY) / 20;

                floatingImage.element.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
            });
        } else {
            // Mobile: flotando de forma fija
            floatingImage.element.style.transform = 'translate(5px, -5px)';
        }
    }
});
